/**
 *
 * CompaniesTable
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Table, Tooltip } from "antd"
import { Link } from "react-router-dom"
import { validate } from "../../utils/functions"
/* eslint-disable react/prefer-stateless-function */
class CompaniesTable extends React.Component {
  state = { sortedInfo: null }

  handleChange = (pagination, filters, sorter) => {
    this.setState({ sortedInfo: sorter })
  }

  render() {
    let { sortedInfo } = this.state
    const { companies, isLoading } = this.props

    sortedInfo = sortedInfo || {}

    const columns = [
      {
        title: "Empresa",
        dataIndex: "name",
        key: "name",
        render: (text, record) => (
          <Link to={`/companies/${record.id_company}`}>{text} </Link>
        ),
        sorter: (a, b) => {
          return a.name.localeCompare(b.name)
        },
        sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,

        width: 204,
      },
      {
        title: "Administradores",
        dataIndex: "admins",
        key: "admins",
        sorter: (a, b) => a.admins - b.admins,
        sortOrder: sortedInfo.columnKey === "admins" && sortedInfo.order,
        width: 147,
      },
      {
        title: "Colaboradores",
        dataIndex: "employees_quantity",
        key: "employees_quantity",
        sorter: (a, b) => a.employees_quantity - b.employees_quantity,
        sortOrder:
          sortedInfo.columnKey === "employees_quantity" && sortedInfo.order,
        render: (text, record) => (
          <Fragment>
            {record.employees_quantity}{" "}
            <span
              style={{
                float: "right",
                width: 94,
                textAlign: "right",
              }}
              className="color-gray-low">
              / {record.collaborator.replace(".", ",")}
            </span>
          </Fragment>
        ),
        width: 143,
      },
      {
        title: "Módulo",
        dataIndex: "platforms_name",
        width: 120,
      },
      {
        title: "Licencia",
        dataIndex: "license",
        width: 179,
      },
      {
        title: "Account manager",
        dataIndex: "account_manager",
        render: (text, record) => {
          if (!text.length) return "-"
          const emailOne = text[0]
          let emailTwo = null
          if (validate.exist(text[1])) {
            emailTwo = text[1]
          }
          const numberCharacters =
            emailOne.length + (validate.exist(emailTwo) ? emailTwo.length : 0)
          let sliceEmails = 2
          if (numberCharacters > 30) {
            if (emailOne.length > 30) {
              sliceEmails = 0
            } else {
              sliceEmails = 1
            }
          }
          const separate = text.map((item) => item).slice(0, sliceEmails)
          const rest = text.map((item) => item).slice(sliceEmails)

          const tooltipText = () => (
            <div style={{ maxHeight: 100, overflow: "auto" }}>
              {rest.map((item, index) => (
                <div style={{ fontSize: "12px" }} key={index}>
                  {item}
                </div>
              ))}
            </div>
          )

          return (
            <>
              {separate.map((item) => (
                <span
                  style={{
                    fontSize: "12px",
                    background: "#F9F9F9",
                    padding: "8px",
                    marginRight: "7px",
                    border: "1px solid #EDE9E9",
                    borderRadius: "4px",
                    maxWidth: text.length > 1 ? "80%" : "100%",
                  }}>
                  {item}
                </span>
              ))}

              {rest?.length >= 1 && (
                <Tooltip placement="bottom" title={tooltipText}>
                  <span
                    style={{
                      fontSize: "12px",
                      background: "#F9F9F9",
                      padding: "8px",
                      marginRight: "7px",
                      border: "1px solid #EDE9E9",
                      borderRadius: "4px",
                      maxWidth: text.length > 1 ? "80%" : "100%",
                    }}>
                    +{rest?.length}
                  </span>
                </Tooltip>
              )}
            </>
          )
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 100,
        render: (_, record) => {
          return (
            <span
              className="color-blue"
              style={{ cursor: "pointer" }}
              onClick={() => {
                this.props.goCompany({ company_id: record.id_company })
              }}>
              Ingresar &gt;
            </span>
          )
        },
      },
    ]

    return (
      <Table
        loading={isLoading}
        columns={columns}
        size="small"
        rowKey={(record) => record.id_company}
        dataSource={Array.isArray(companies) ? companies : []}
        onChange={this.handleChange}
        pagination={{
          pageSizeOptions: ["15", "25", "50", "100"],
          showSizeChanger: true,
          size: "default",
          defaultPageSize: 15,
        }}
      />
    )
  }
}

CompaniesTable.propTypes = {}

export default CompaniesTable
